<mat-card appearance="outlined">
  <mat-card-title>
    {{title}}
    <button (click)="increaseFont()" mat-icon-button>
      <mat-icon>add_circle</mat-icon>
    </button>
    <button (click)="decreaseFont()" mat-icon-button>
      <mat-icon>remove_circle</mat-icon>
    </button>
    <button (click)="changeFold()" *ngIf="!isFolded" mat-button>
      <mat-icon>vertical_align_top</mat-icon>
    </button>
    <button (click)="changeFold()" *ngIf="isFolded" mat-button>
      <mat-icon>vertical_align_bottom</mat-icon>
    </button>
    <button (click)="changeTheme()" *ngIf="themeDark" mat-button>light</button>
    <button (click)="changeTheme()" *ngIf="!themeDark" mat-button>dark</button>
  </mat-card-title>
  <div #aceEditor></div>
</mat-card>

